import { render, staticRenderFns } from "./BasicList.vue?vue&type=template&id=9fcba204&scoped=true&"
import script from "./BasicList.vue?vue&type=script&lang=js&"
export * from "./BasicList.vue?vue&type=script&lang=js&"
import style0 from "./BasicList.vue?vue&type=style&index=0&id=9fcba204&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcba204",
  null
  
)

export default component.exports